import { toast } from "react-toastify";

const ToastType = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
};

const formatMessage = (message) => {
  let messages = message;

  if (Array.isArray(messages)) {
  } else if (typeof messages === "object") {
    messages = Object.values(messages);
  } else if (typeof messages === "string" && messages.includes(",")) {
    messages = messages.split(",").map((m) => m.trim());
  }

  if (Array.isArray(messages)) {
    return (
      <ul style={{ paddingLeft: "1rem", margin: 0 }}>
        {messages.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul>
    );
  }

  return messages;
};

export default function fireToast(type, message, position, isAutoClose) {
  if (type === ToastType.ERROR) {
    if (
      message === "Session invalidated" ||
      message === "Not authorized to access this route" ||
      message === "Password was changed. Please sign in again."
    ) {
      localStorage.clear();
      window.location.href = "/";
      return;
    }

    toast.error(formatMessage(message), {
      position,
      autoClose: isAutoClose ? 1500 : 20000,
    });
    return;
  }

  if (type === ToastType.SUCCESS) {
    toast.success(message, {
      position,
      autoClose: isAutoClose ? 1500 : 20000,
    });
    return;
  }

  if (type === ToastType.INFO) {
    toast.info(message, {
      position,
      autoClose: isAutoClose ? 1500 : 20000,
    });
    return;
  }

  if (type === ToastType.WARNING) {
    toast.warning(message, {
      position,
      autoClose: isAutoClose ? 1500 : 20000,
    });
  }
}
